"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitByCommaOrSpace = void 0;
var COMMA_SPACE_MULTI_SPACE_REGEX = /(,(\s+)?|\s\s+)/g;
/**
 * Splits a string by commas and spaces, removes extra white space
 *
 * @param  {string} str comma or space separated string to be split
 * @return {array}      list of split strings
 */

var splitByCommaOrSpace = function splitByCommaOrSpace(str) {
  return str // change all commas to spaces and trim all multispace to single space
  .replace(COMMA_SPACE_MULTI_SPACE_REGEX, ' ') // split on single space
  .split(' ') // filter empties
  .filter(function (s) {
    return !!s;
  });
};

exports.splitByCommaOrSpace = splitByCommaOrSpace;
//# sourceMappingURL=split-by-comma-or-space.js.map